import document from "@ingka/ssr-icon/paths/document";
import SSRIcon from "@ingka/ssr-icon";
import Text from "@ingka/text";
import { AuthenticatedImage } from "@/components/AuthenticatedResource/AuthenticatedImage";

type Props = {
  fileName: string;
  assetId: number;
  extension: string;
};

const Preview = ({ fileName, assetId, extension }: Props) => {
  return (
    <div className="flex flex-col">
      <Text
        tagName="span"
        title={fileName}
        className="mb-space25 min-h-[1.2rem] cursor-pointer truncate pt-space50"
      >
        {fileName}
      </Text>
      <div className="flex h-[15rem] w-full items-center justify-center border border-solid border-neutral-300 bg-neutral-100">
        {extension === "pdf" ? (
          <AuthenticatedImage className="h-full" assetId={assetId} />
        ) : (
          <SSRIcon paths={document} className="h-16 w-16 text-neutral-500" />
        )}
      </div>
    </div>
  );
};

export default Preview;
